/**
 * See https://docs.metapic.dev/engineering/image-processing
 */
export type ProcessableServerImageType = {
  key: string
  base_url: string
  content_type?: string
  url?: string
}

export type ProcessableImageType = {
  key: string
  baseUrl: string
  contentType?: string
  url?: string
}

export const normalizeImage = (image: ProcessableServerImageType): ProcessableImageType => ({
  key: image.key,
  baseUrl: image.base_url,
  contentType: image.content_type,
  url: image.url,
})
